import { render } from "./ShowComponent.vue?vue&type=template&id=08382bb8&scoped=true"
import script from "./ShowComponent.vue?vue&type=script&lang=js"
export * from "./ShowComponent.vue?vue&type=script&lang=js"

import "./ShowComponent.vue?vue&type=style&index=0&id=08382bb8&scoped=true&lang=css"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08382bb8"]])

export default __exports__